import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateVideoPlayerCommentMarkers } from 'actions/videoPlayer';
import {
  EMBED_VIDEO_CORRECT_PASS,
  EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED,
} from 'constants/messages';
import { fetchCommentsCreator } from 'creators/comments';

import AddComment from './add-comment';
import CommentsContent from './comments-content';

import './styles.less';

const Comments = class extends Component {
  render() {
    const { comments, hasFetched, shouldNotLoad } = this.props;

    if (shouldNotLoad) {
      return null;
    }

    return (
      <div className="comments-view">
        <AddComment />
        {comments.length > 0 && hasFetched && <CommentsContent />}
      </div>
    );
  }

  componentDidMount() {
    const { shouldNotLoad } = this.props;

    window.top.addEventListener(
      'message',
      event => {
        switch (event.data.type) {
          case EMBED_VIDEO_CORRECT_PASS:
            this.fetchCommentsAndSendMarkers();
            break;
          case EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED:
            this.fetchCommentsAndSendMarkers();
            break;
          default:
            break;
        }
      },
      false
    );

    if (shouldNotLoad) {
      return;
    }

    this.fetchCommentsAndSendMarkers();
  }

  componentDidUpdate(prevProps) {
    const {
      comments: prevComments,
      hasFetched: prevHasFetched,
      iframeLoaded: prevIframeLoaded,
      password: prevPassword,
      video: prevVideo,
    } = prevProps;

    const { comments, hasFetched, iframeLoaded, password, video } = this.props;

    if (video == null) {
      return;
    }

    // if we just got the video, fetch the first comments
    if (video != null && prevVideo == null && !video.needs_password) {
      return this.fetchCommentsAndSendMarkers();
    }

    // if we just got the password, fetch comments
    if (video.needs_password && prevPassword == null && password != null) {
      return this.fetchCommentsAndSendMarkers();
    }

    // if the iframe has just loaded, send the markers
    if (iframeLoaded && !prevIframeLoaded) {
      return this.sendMarkers();
    }

    // send markers anytime comments length changes except first fetch
    if (
      prevComments.length !== comments.length &&
      prevHasFetched === hasFetched
    ) {
      this.sendMarkers();
    }
  }

  fetchCommentsAndSendMarkers = async () => {
    const { video, password } = this.props;

    if (video == null || (video.needs_password && password == null)) {
      return;
    }

    await this.props.fetchComments();
    this.sendMarkers();
  };

  sendMarkers() {
    const { comments, iframeLoaded } = this.props;

    if (!iframeLoaded) {
      return;
    }

    this.props.updateVideoPlayerCommentMarkers(
      comments.map(comment => {
        return { time: comment.time_stamp };
      })
    );
  }
};

const mapStateToProps = state => {
  const { password, video } = state.share_video;
  const { comments, has_fetched: hasFetched } = state.comments;

  const shouldNotLoad =
    video == null ||
    (video.needs_password && !password) ||
    video.viewer_needs_permission;

  return {
    shouldNotLoad,
    comments,
    hasFetched,
    password,
    video,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchComments: () => dispatch(fetchCommentsCreator()),
    updateVideoPlayerCommentMarkers: markers =>
      dispatch(updateVideoPlayerCommentMarkers(markers)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
